import { render, staticRenderFns } from "./ChatMessageBox.vue?vue&type=template&id=a569e804&scoped=true"
import script from "./ChatMessageBox.vue?vue&type=script&lang=js"
export * from "./ChatMessageBox.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageBox.vue?vue&type=style&index=0&id=a569e804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a569e804",
  null
  
)

export default component.exports